var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',{staticClass:"demo__button demo__button--gradient demo__button--two-line this__btn",on:{"click":function($event){return _vm.$store.dispatch('updateSubsModalStatus', true)}}},[_vm._v(" "+_vm._s(_vm.$t("Subs.Connectv2"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }